import { graphql } from 'react-relay/legacy';

export const tradeGeneralOnboardingQuery = graphql`
    query tradeGeneralOnboardingQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                verifiedTradeSubStatus
            }
        }
    }
`;
